import { useState } from 'react';
import { ReactSVG } from 'react-svg';
import Communicator from '../../Helper/Communicator';
import { isPassToAgentItem, startPassToAgent } from '../../Helper/PassToAgent';
import { ConfigMenuItem } from '../../Stores/Config';
import { useRouterStore } from '../../Stores/Router';
import { useTicketStore } from '../../Stores/Ticket';
import { activateOnKey } from '../../Helper/a11y';
import "./HomeButtonOptionsButton.scss";

function HomeButtonOptionsButton({ menuItem, index }: {
    menuItem: ConfigMenuItem;
    index: number;
}) {
    const [isLoading, setIsLoading] = useState(false);
    const routerStore = useRouterStore();
    const ticketStore = useTicketStore();

    const handleClick = () => {
        if (isLoading) {
            return;
        }

        // Make component loading
        setIsLoading(true);

        Communicator.trackWidgetEvent("gleap-home-menu-clicked", {
            title: menuItem.title,
            actionType: menuItem.actionType,
        });

        if (menuItem.actionType === "CUSTOM_ACTION") {
            if (menuItem.actionBody) {
                Communicator.runCustomAction(menuItem.actionBody);
                Communicator.closeWidget();
            }
        } else if (menuItem.actionType === "REDIRECT_URL") {
            if (menuItem.actionBody) {
                Communicator.openURL(menuItem.actionBody, menuItem.actionOpenInNewTab ? true : false);
                Communicator.closeWidget();
            }
        } else if (isPassToAgentItem(menuItem)) {
            startPassToAgent(menuItem);
        } else if (menuItem.actionType === "BOT") {
            ticketStore.createNewConversation({
                botId: menuItem.botId,
                isManualStart: true,
            });
        } else {
            routerStore.pushPage("flow", {
                flowId: menuItem.actionType,
            });
        }
        // Release the click guard like WidgetMenuButton does — without this a
        // REDIRECT_URL / CUSTOM_ACTION that closes (but doesn't unmount) the
        // widget left the button permanently inert on reopen.
        setIsLoading(false);
    };

    return (
        <div id={`menu-item-${index}`} className="home-button" role="button" tabIndex={0} onClick={handleClick} onKeyDown={activateOnKey(handleClick)}>
            <div className="home-button-icon">
                {(menuItem.icon && menuItem.icon.endsWith(".svg")) ? <ReactSVG src={menuItem.icon} /> : <img src={menuItem.icon} alt={menuItem.title} />}
            </div>
            <div className='home-button-title'>{menuItem.title}</div>
        </div>
    );
}

export default HomeButtonOptionsButton;
